export const translations = {
  de: {
    // Navigation
    nav: {
      home: "Startseite",
      solutions: "Lösungen",
      portfolio: "Portfolio",
      partner: "Partner/Kunden",
      about: "Über uns",
      contact: "Kontakt",
      faq: "FAQ",
      bookDemo: "Termin buchen",
      getQuote: "Demo / Anfrage",
      freeTrial: "Kostenlos testen"
    },
    // Hero Section
    hero: {
      subtitle: "EINFACHE LÖSUNGEN",
      titlePrefix: "Corporate E-Learning",
      titleSuffix: "wir schaffen Bewusstsein",
      words: ["designen", "entwickeln", "liefern", "ermöglichen"],
      description: "Als Full-Service E-Learning Anbieter unterstützen wir Sie von der Konzeption bis zum Rollout – mit System, Inhalten und Expertise.",
      cta: {
        demo: "Demo / Anfrage",
        quote: "Demo / Anfrage",
        trial: "Kostenlos testen"
      }
    },
    // Stats
    stats: {
      solutions: "Lösungen geliefert",
      experience: "Jahre Erfahrung",
      clients: "Zufriedene Kunden",
      languages: "Sprachen"
    },
    // E-Learnings Section
    elearnings: {
      subtitle: "UNSERE E-LEARNINGS",
      title: "Sofort einsatzbereit",
      description: "In der heutigen schnelllebigen Welt profitieren Organisationen von fertigen E-Learning-Lösungen, die Wissen klar und effizient vermitteln.",
      viewAll: "Alle ansehen",
      view: "Ansehen"
    },
    // Benefits
    benefits: {
      subtitle: "IHRE VORTEILE",
      title: "Warum e-Matrix?",
      items: {
        ready: {
          title: "Sofort einsatzbereit",
          description: "Unsere Standardmodule sind direkt nutzbar und nahtlos integrierbar."
        },
        multilingual: {
          title: "Mehrsprachig",
          description: "Verfügbar in mehreren Sprachen für internationale Teams."
        },
        compliant: {
          title: "Gesetzeskonform",
          description: "Erfüllt alle rechtlichen Anforderungen und Compliance-Standards."
        },
        scalable: {
          title: "Anpassbar & Skalierbar",
          description: "Flexibel an Ihr Corporate Design und Ihre Anforderungen anpassbar."
        },
        efficient: {
          title: "Zeit- & Kostensparend",
          description: "Automatisierte Prozesse reduzieren Verwaltungsaufwand."
        },
        secure: {
          title: "Sicher & Zuverlässig",
          description: "Höchste Sicherheitsstandards für Ihre Unternehmensdaten."
        }
      }
    },
    // Platform
    platform: {
      subtitle: "UNSER SYSTEM",
      title: "ematrixsys",
      description: "Eine innovative, skalierbare Lernplattform, die entwickelt wurde, um die Lerneffizienz in Ihrem gesamten Unternehmen zu steigern.",
      features: {
        userFriendly: {
          title: "Benutzerfreundlich",
          description: "Intuitive Oberfläche für einfachen Zugang zu Inhalten."
        },
        automation: {
          title: "Automatisierung",
          description: "Automatische Kurszuweisungen, Erinnerungen und Zertifikate."
        },
        flexible: {
          title: "Flexibel",
          description: "Anpassbar an Ihre spezifischen Anforderungen."
        },
        secure: {
          title: "Sicher",
          description: "Enterprise-grade Sicherheit für Ihre Daten."
        }
      }
    },
    // Services
    services: {
      subtitle: "UNSERE LEISTUNGEN",
      title: "Alles aus einer Hand",
      items: {
        integration: {
          title: "Technische Integration",
          description: "Verschiedene Schnittstellen zu Ihren bestehenden Systemen."
        },
        content: {
          title: "E-Learning Inhalte",
          description: "Maßgeschneidert oder sofort einsatzbereit – flexibel und skalierbar."
        },
        consulting: {
          title: "Beratung",
          description: "Wir unterstützen Sie bei der strategischen Planung."
        },
        support: {
          title: "Support",
          description: "Unser Team steht Ihnen bei Fragen zur Verfügung."
        }
      }
    },
    // Testimonials
    testimonials: {
      subtitle: "KUNDENSTIMMEN",
      title: "Das sagen unsere Kunden"
    },
    // CTA
    cta: {
      title: "Bereit für modernes E-Learning?",
      description: "Kontaktieren Sie uns noch heute und erfahren Sie, wie wir Ihre Schulungen digitalisieren können.",
      button: "Jetzt kontaktieren"
    },
    // Newsletter
    newsletter: {
      title: "Newsletter abonnieren",
      description: "Erhalten Sie Updates zu neuen E-Learnings und Branchennews.",
      placeholder: "Ihre E-Mail-Adresse",
      button: "Abonnieren",
      success: "Erfolgreich abonniert!",
      error: "Diese E-Mail ist bereits registriert."
    },
    // Footer
    footer: {
      company: "e-Matrix Innovations",
      tagline: "Corporate E-Learning - wir schaffen Bewusstsein",
      links: {
        solutions: "Lösungen",
        portfolio: "Portfolio",
        about: "Über uns",
        contact: "Kontakt",
        privacy: "Datenschutz",
        imprint: "Impressum"
      },
      contact: {
        title: "Kontakt",
        address: "Wien, Österreich",
        email: "info@e-matrix.at"
      },
      copyright: "Alle Rechte vorbehalten."
    },
    // Contact Page
    contact: {
      title: "Kontakt",
      subtitle: "Wir freuen uns auf Ihre Nachricht",
      form: {
        name: "Name",
        email: "E-Mail",
        company: "Unternehmen (optional)",
        phone: "Telefon (optional)",
        subject: "Betreff",
        message: "Nachricht",
        requestType: "Anfragetyp",
        types: {
          contact: "Allgemeine Anfrage",
          demo: "Demo anfragen",
          quote: "Angebot anfordern",
          visitor: "Besucher-Unterweisung"
        },
        submit: "Absenden",
        success: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
      }
    },
    // About Page
    about: {
      hero: {
        subtitle: "ÜBER UNS",
        title: "Unsere Geschichte",
        description: "Seit 2015 entwickeln wir innovative E-Learning-Lösungen für Unternehmen und Organisationen."
      },
      mission: {
        title: "Unsere Mission",
        description: "Wir machen Unternehmensschulungen einfach, effizient und wirkungsvoll. Mit modernen E-Learning-Lösungen und einer benutzerfreundlichen Plattform unterstützen wir Unternehmen dabei, ihre Mitarbeiter optimal zu schulen."
      },
      values: {
        title: "Unsere Werte",
        items: {
          quality: {
            title: "Qualität",
            description: "Höchste Standards in allem was wir tun."
          },
          innovation: {
            title: "Innovation",
            description: "Ständige Weiterentwicklung und neue Ideen."
          },
          partnership: {
            title: "Partnerschaft",
            description: "Langfristige Zusammenarbeit mit unseren Kunden."
          }
        }
      }
    },
    // Solutions Page
    solutions: {
      hero: {
        subtitle: "UNSERE LÖSUNGEN",
        title: "E-Learning für jeden Bedarf",
        description: "Entdecken Sie unsere vielfältigen E-Learning-Module für Compliance, Sicherheit und mehr."
      },
      categories: {
        all: "Alle",
        safety: "Sicherheit",
        compliance: "Compliance",
        technology: "Technologie"
      }
    },
    // Portfolio Page
    portfolio: {
      hero: {
        subtitle: "PORTFOLIO",
        title: "Unsere Projekte",
        description: "Mehr als 100 erfolgreich umgesetzte E-Learning-Lösungen."
      }
    },
    // Chat Widget
    chat: {
      title: "Live-Chat",
      subtitle: "Wir sind für Sie da",
      placeholder: "Ihre Nachricht...",
      send: "Senden",
      nameRequired: "Bitte geben Sie Ihren Namen ein",
      emailRequired: "Bitte geben Sie Ihre E-Mail ein",
      success: "Nachricht gesendet! Wir melden uns in Kürze.",
      offline: "Wir sind gerade nicht online. Bitte hinterlassen Sie uns eine Nachricht."
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      solutions: "Solutions",
      portfolio: "Portfolio",
      partner: "Partners/Clients",
      about: "About",
      contact: "Contact",
      faq: "FAQ",
      bookDemo: "Book Appointment",
      getQuote: "Get Quote",
      freeTrial: "Free Trial"
    },
    // Hero Section
    hero: {
      subtitle: "SIMPLE SOLUTIONS",
      titlePrefix: "Corporate E-Learning",
      titleSuffix: "we create awareness",
      words: ["design", "develop", "deliver", "enable"],
      description: "As a full-service e-learning provider, we support you from concept to rollout — with a system, content, and expertise.",
      cta: {
        demo: "Book Demo",
        quote: "Get Quote",
        trial: "Free Trial"
      }
    },
    // Stats
    stats: {
      solutions: "Solutions Delivered",
      experience: "Years Experience",
      clients: "Happy Clients",
      languages: "Languages"
    },
    // E-Learnings Section
    elearnings: {
      subtitle: "OUR E-LEARNINGS",
      title: "Ready to Use",
      description: "In today's fast-paced world, organizations benefit from ready-made e-learning solutions that deliver knowledge clearly and efficiently.",
      viewAll: "View All",
      view: "View"
    },
    // Benefits
    benefits: {
      subtitle: "YOUR BENEFITS",
      title: "Why e-Matrix?",
      items: {
        ready: {
          title: "Ready to Use",
          description: "Our standard modules are instantly available and seamlessly integrable."
        },
        multilingual: {
          title: "Multilingual",
          description: "Available in multiple languages for international teams."
        },
        compliant: {
          title: "Legally Compliant",
          description: "Meets all legal requirements and compliance standards."
        },
        scalable: {
          title: "Customizable & Scalable",
          description: "Flexibly adaptable to your corporate design and requirements."
        },
        efficient: {
          title: "Time & Cost Saving",
          description: "Automated processes reduce administrative overhead."
        },
        secure: {
          title: "Secure & Reliable",
          description: "Highest security standards for your company data."
        }
      }
    },
    // Platform
    platform: {
      subtitle: "OUR SYSTEM",
      title: "ematrixsys",
      description: "An innovative, scalable learning platform designed to enhance learning efficiency across your organization.",
      features: {
        userFriendly: {
          title: "User-Friendly",
          description: "Intuitive interface for easy access to content."
        },
        automation: {
          title: "Automation",
          description: "Automatic course assignments, reminders, and certificates."
        },
        flexible: {
          title: "Flexible",
          description: "Adaptable to your specific requirements."
        },
        secure: {
          title: "Secure",
          description: "Enterprise-grade security for your data."
        }
      }
    },
    // Services
    services: {
      subtitle: "OUR SERVICES",
      title: "All-in-One Solutions",
      items: {
        integration: {
          title: "Technical Integration",
          description: "Various interfaces to your existing systems."
        },
        content: {
          title: "E-Learning Content",
          description: "Custom-designed or ready-to-use — flexible and scalable."
        },
        consulting: {
          title: "Consulting",
          description: "We support you with strategic planning."
        },
        support: {
          title: "Support",
          description: "Our team is available for your questions."
        }
      }
    },
    // Testimonials
    testimonials: {
      subtitle: "TESTIMONIALS",
      title: "What Our Clients Say"
    },
    // CTA
    cta: {
      title: "Ready for Modern E-Learning?",
      description: "Contact us today and discover how we can digitize your training.",
      button: "Contact Now"
    },
    // Newsletter
    newsletter: {
      title: "Subscribe to Newsletter",
      description: "Get updates on new e-learnings and industry news.",
      placeholder: "Your email address",
      button: "Subscribe",
      success: "Successfully subscribed!",
      error: "This email is already registered."
    },
    // Footer
    footer: {
      company: "e-Matrix Innovations",
      tagline: "Corporate E-Learning - we create awareness",
      links: {
        solutions: "Solutions",
        portfolio: "Portfolio",
        about: "About Us",
        contact: "Contact",
        privacy: "Privacy Policy",
        imprint: "Imprint"
      },
      contact: {
        title: "Contact",
        address: "Vienna, Austria",
        email: "info@e-matrix.at"
      },
      copyright: "All rights reserved."
    },
    // Contact Page
    contact: {
      title: "Contact",
      subtitle: "We look forward to hearing from you",
      form: {
        name: "Name",
        email: "Email",
        company: "Company (optional)",
        phone: "Phone (optional)",
        subject: "Subject",
        message: "Message",
        requestType: "Request Type",
        types: {
          contact: "General Inquiry",
          demo: "Request Demo",
          quote: "Request Quote",
          visitor: "Visitor Instruction Inquiry"
        },
        submit: "Submit",
        success: "Thank you! We will get back to you shortly.",
        error: "Something went wrong. Please try again."
      }
    },
    // About Page
    about: {
      hero: {
        subtitle: "ABOUT US",
        title: "Our Story",
        description: "Since 2015, we have been developing innovative e-learning solutions for companies and organizations."
      },
      mission: {
        title: "Our Mission",
        description: "We make corporate training simple, efficient, and effective. With modern e-learning solutions and a user-friendly platform, we help companies optimally train their employees."
      },
      values: {
        title: "Our Values",
        items: {
          quality: {
            title: "Quality",
            description: "Highest standards in everything we do."
          },
          innovation: {
            title: "Innovation",
            description: "Constant development and new ideas."
          },
          partnership: {
            title: "Partnership",
            description: "Long-term collaboration with our clients."
          }
        }
      }
    },
    // Solutions Page
    solutions: {
      hero: {
        subtitle: "OUR SOLUTIONS",
        title: "E-Learning for Every Need",
        description: "Discover our diverse e-learning modules for compliance, safety, and more."
      },
      categories: {
        all: "All",
        safety: "Safety",
        compliance: "Compliance",
        technology: "Technology"
      }
    },
    // Portfolio Page
    portfolio: {
      hero: {
        subtitle: "PORTFOLIO",
        title: "Our Projects",
        description: "Over 100 successfully implemented e-learning solutions."
      }
    },
    // Chat Widget
    chat: {
      title: "Live Chat",
      subtitle: "We're here to help",
      placeholder: "Your message...",
      send: "Send",
      nameRequired: "Please enter your name",
      emailRequired: "Please enter your email",
      success: "Message sent! We'll get back to you shortly.",
      offline: "We're currently offline. Please leave us a message."
    }
  }
};
